module.exports = __webpack_public_path__ + "static/media/ad4.8c6b6702.png";